import {
	STButton,
	STDescription,
	STDivider,
	STEventHot,
	STEventWrapper,
	STHeaderWrapper,
	STSubTitle
} from '../../../Event/Landing/styles';
import {Button, Slider} from '@microfrontends/react-components';
import {EventHotItem} from '../../../Event/components/EventHotItem';
import React, {useContext} from 'react';
import {IEvent} from '../../../Event/assets/types';
import AppContext from '../../../../context/AppContext';
import {ContentContainer} from '../styles';
import SectionTitle from '../../components/PageTitle';

export type TCareerNewbieHotEventsProps = {
	events: IEvent[]
	utm?: string
}
const CareerNewbieHotEvents = ({events, utm}: TCareerNewbieHotEventsProps) =>
	{
		return (events.length ? <ContentContainer narrowedWidth={true}>
			<SectionTitle light>
				Những sự kiện hấp dẫn
			</SectionTitle>
			<div style={{background: 'white'}}>
				<STEventHot>
					<Slider
						id="event-hot"
						// autoEnable={eventHots.length > 1}
						// autoTime={2000}
						pagination={{maxShow: 5}}
						container={{style: {width: '100%'}}}
					>
						{events.map((item) => (
							<EventHotItem key={item.eventId} utm={utm} event={item}/>
						))}
					</Slider>
				</STEventHot>
			</div>
		</ContentContainer> : <></>)
	}
export default CareerNewbieHotEvents
